import React from 'react';

const Blog = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header Section */}
      <section className="bg-[#000C66] text-white p-10 md:p-20">
        <h1 className="text-3xl md:text-5xl font-bold mb-4 border-b border-white pb-2 inline-block">Revolutionizing Digital Document Management with TrustForge</h1>
      </section>

      {/* Content Section */}
      <section className="bg-white p-6 md:p-20">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">About Us</h2>
          <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-6">
            At TrustForge, we envision a future where digital documents are universally trusted and effortlessly verified. Our mission is to foster trust and integrity in the digital age by leveraging the unparalleled security of blockchain technology.
          </p>
        </div>

        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">Our Vision</h2>
          <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-6">
            We believe in a world where digital documents are not just convenient, but also secure and reliable. By integrating state-of-the-art blockchain technology, TrustForge aims to usher in a new era of digital integrity and security. We are committed to revolutionizing digital document management, making it easier and safer for users to certify and verify their documents.
          </p>
        </div>

        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">Our Technology</h2>
          <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-6">
            TrustForge stands at the forefront of digital document management innovation. Our platform provides a secure and transparent environment for document certification and verification. Here's how we do it:
          </p>
          <ul className="list-disc list-inside text-gray-700 text-lg md:text-xl mb-6">
            <li className="mb-4">Blockchain Integration: By using blockchain technology, we ensure that each document is immutable and verifiable. This means that once a document is created and recorded on the blockchain, it cannot be altered without detection, providing a permanent and tamper-proof record.</li>
            <li className="mb-4">User-Friendly Interface: Our platform is designed with the user in mind. Whether you're an individual or an organization, TrustForge makes it easy to manage, share, and verify digital documents.</li>
            <li>Enhanced Security: TrustForge employs advanced encryption and security protocols to protect your documents. Our technology ensures that your data is safe from unauthorized access and tampering.</li>
          </ul>
        </div>

        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">Why TrustForge?</h2>
          <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-6">
            <strong>Reliability:</strong> Documents certified with TrustForge are universally trusted and can be effortlessly verified, making them ideal for legal, financial, and personal use.<br/>
            <strong>Transparency:</strong> Our use of blockchain technology ensures complete transparency in the document verification process. Every change and certification is recorded and visible.<br/>
            <strong>Ease of Use:</strong> Managing and sharing your digital documents has never been easier. TrustForge’s intuitive platform allows you to handle all your documents from a single, secure interface.
          </p>
        </div>

        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">Join Us in the Digital Age</h2>
          <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-6">
            As we continue to evolve and expand our services, we invite you to join us on our journey towards a more secure and transparent digital future. Whether you’re looking to protect your personal documents or need a reliable solution for your organization, TrustForge is here to help.
          </p>
          <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-6">
            TrustForge is more than just a platform – it's a commitment to trust, integrity, and security in the digital age. Join us today and experience the future of digital document management.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Blog;
